var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4599 2.90754C17.676 3.07534 17.7837 3.34755 17.7407 3.61781L15.5936 17.1178C15.5528 17.3746 15.3819 17.5919 15.142 17.6921C14.9021 17.7923 14.6274 17.7611 14.4161 17.6097L10.5141 14.8136L7.71014 17.5379C7.50678 17.7355 7.20939 17.8015 6.94153 17.7085C6.67368 17.6155 6.48116 17.3795 6.44398 17.0984L5.78159 12.0912L2.18941 10.4569C1.9195 10.3341 1.74728 10.0638 1.75003 9.76723C1.75279 9.4707 1.93 9.20364 2.20216 9.08588L16.7022 2.81168C16.9533 2.70301 17.2437 2.73975 17.4599 2.90754ZM4.34887 9.79139L6.78117 10.898C7.01658 11.0051 7.18019 11.2259 7.21411 11.4823L7.73529 15.4221L9.91854 13.3008C10.1789 13.0479 10.583 13.0177 10.878 13.2291L14.3029 15.6832L16.0449 4.73049L4.34887 9.79139Z",
    fill: "#808085"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.656375a6.svg";
export { ForwardRef as ReactComponent };